import React from "react";
import {withRouter} from 'react-router-dom';
import {Route} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import Processing from 'pages/Processing/Processing';
import DefaultLayout from "layouts/DefaultLayout";
import userManager from "userManager";
import {storeRedirect} from "redux/actions";

const PrivateRoute = ({component: Component, ...rest}) => {
  const dispatch = useDispatch();
  const oidc = useSelector(state => state.oidc);
  const {user, isLoadingUser} = oidc;
  const userExists = user && !isLoadingUser;
  const formData = useSelector(state => state.form);
  const {redirectTo} = formData;

  return <Route {...rest} render={(props) => {
    if (userExists || (user && !user.expired)) {
      return <Component {...props} />;
    } else {
      if (rest.storeRedirect && !redirectTo) {
        
        if (rest.path && rest.path.substr(-3) === ':id') {
          dispatch(storeRedirect(rest.location.pathname));
        } else {
          dispatch(storeRedirect(rest.path));
        }
      }
      userManager.clearStaleState().then(() => {
        userManager.signinRedirect();
      })
      return <DefaultLayout>
        <Processing message={"Redirecting..."}/>
      </DefaultLayout>
    }
  }}/>
}

export default withRouter(props => <PrivateRoute {...props}/>);
